export default __webpack_public_path__ + "static/media/basketball.3cc2e089.svg";